import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(c, e) {
  return r(), o("svg", t, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M10.5 7.021c.38 0 .69.309.69.69v2.504l3.284 3.285a.69.69 0 0 1-.975.975l-3.48-3.482a.7.7 0 0 1-.208-.493V7.71c0-.38.308-.689.689-.689"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 2a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M5.464 5.464a7.122 7.122 0 1 1 10.072 10.072A7.122 7.122 0 0 1 5.464 5.464",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
